import { SIDE_APP_ID, TENANT_ID } from '@@types/common';
import SideApp from '@@types/SideApp';
import SideAppContent from '@@types/SideAppContent';

import { URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';
import { getContents } from '~/utils/apiUtil';

class SideAppApi {
  constructor(private api: Api2) {}

  fetchSideApps = (tenantId: TENANT_ID): Promise<SideApp[]> => {
    return this.api.ignoreErrorRequester.get(`${URLS.SIDE_APP_API}/tenants/${tenantId}`).then(getContents) as Promise<
      SideApp[]
    >;
  };

  fetchSideAppContents = (tenantId: TENANT_ID, sideAppId: SIDE_APP_ID): Promise<SideAppContent> => {
    return this.api.resultRequester.post(`${URLS.SIDE_APP_API}/tenants/${tenantId}/${sideAppId}`);
  };
}

export default SideAppApi;
